import { defineComponent as _defineComponent } from 'vue';
import EnShortcutFilterButton from './EnShortcutFilterButton.vue';
import { ShortcutFilterButtonState } from '../types/shortcutFilterButtonStates.ts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnDataGridShortcutFilterBar',
    props: {
        /**
         * Array of shortcut filter button configurations
         */
        shortcutFilterButtons: (Array),
        /**
         * Shows number of filtered elements
         */
        totalCount: Number,
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        function getButtonState(button) {
            if (button.disabled) {
                return ShortcutFilterButtonState.Disabled;
            }
            return button.isActive ? ShortcutFilterButtonState.Active : ShortcutFilterButtonState.Default;
        }
        const __returned__ = { props, getButtonState, EnShortcutFilterButton };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
